import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { getToken, getUser, setUserSession } from "../../Utils/Common";
import { useSelector, useDispatch } from "react-redux";
import { setUserCredits } from "../../features/counter/counterSlice";
import { ResponseMessage } from "../../components/messages/response-message";

function CancelReason(props) {
  const [subscription, setSubscription] = useState({});
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const user = getUser();
  const token = getToken();
  const [errorMessage, setErrorMessage] = useState("");
  const [sucessMessage, setsucessMessage] = useState("");
  const [error, setError] = useState([]);
  const dispatch = useDispatch();
  const [state, setState] = React.useState({
    cancellation_reason: "",
  });
  const [isAnother, setIsAnother] = useState("");

  useEffect(() => {
    //Check to see if this is a redirect back from Checkout
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API_URL}v1/user/get-subscription`,
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      // data: {
      //     price: "price_1KhY8bHuNOGPY9jaCIulrQ90",
      // },
    })
      .then((response) => {
        if (response.status === 200) {
          console.log(response.data.data);
          setSubscription(response.data.data);
          setIsAnother("");
          // setIsAnother("enable");
          // setUserSession(token, response.data.user);
          // setLoader(false);
        }
      })
      .catch((error) => {
        setLoader(false);
        if (error.response.status === 500) {
          console.log(error.response);
        } else if (error.response.status === 401) {
          console.log(error.response);
        } else if (error.response.status === 404) {
          console.log(error.response.data.message);
          setMessage(error.response.data.message);
        } else {
        }
      });
  }, []);

  const handleChange = (event) => {
    const value = event.target.value;
    console.log(value);
    setState({
      ...state,
      [event.target.name]: value,
    });
  };

  const handleReasonChange = (event) => {
    const value = event.target.value;
    console.log(value);
    setState({
      [event.target.name]: value,
    });
    setIsAnother("enable");
  };

  const cancelSubscription = () => {
    // console.log('click')
    setLoader(true);
    axios({
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}v1/user/cancel-subscription/${subscription.id}?cancellation_reason=${state.cancellation_reason}`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          console.log(response);
          setStatus(200);
          setMessage(response.data.data.message);
          setSubscription(response.data.data);
          setLoader(false);
          dispatch(setUserCredits(response.data.user));
          navigate("/account/cancellation/confirm");
        }
      })
      .catch((error) => {
        setLoader(false);
        if (error.response.status === 500) {
          console.log(error.response);
        } else if (error.response.status === 401) {
          console.log(error.response);
        } else {
          setStatus(422);
          // console.log(error.response);
          setMessage(error.response.data.message);
          setError(error.response.data.errors);
          console.log(error.response.data.errors);
        }
      });
  };
  console.log(error);
  return (
    <div className="container">
      <div className="card mb-5 mb-xl-8 p-8" style={{ marginTop: "140px" }}>
        <ResponseMessage status={status} message={message} />
        <div className="d-flex justify-content-center">
          <div
            className={loader === true ? "spinner-border" : ""}
            role="status"
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
        <div className="fs-1 mt-5">
          {" "}
          In order to improve our services, can you give us a reason for your
          departure?{" "}
        </div>
        <p className="alert-danger fs-1">
          {error.cancellation_reason !== undefined &&
          error.cancellation_reason[0]
            ? error.cancellation_reason[0]
            : ""}
        </p>

        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col-12 mt-8 fs-3 p-3">
                <input
                  className="form-check-input h-20px w-20px m-1"
                  type="radio"
                  name="cancellation_reason"
                  id="cancellation_reason"
                  value="The level of difficulty in French is to HIGH for me"
                  onChange={handleChange}
                />
                <span className="m-6">
                  The level of difficulty in French is to HIGH for me
                </span>
              </div>

              <div className="col-12 mt-8 fs-3">
                <input
                  className="form-check-input h-20px w-20px m-1"
                  type="radio"
                  name="cancellation_reason"
                  id="cancellation_reason"
                  value="The level of difficulty in French is to LOW for me"
                  onChange={handleChange}
                />
                <span className="m-6">
                  The level of difficulty in French is to LOW for me
                </span>
              </div>

              <div className="col-12 mt-8 fs-3">
                <input
                  className="form-check-input h-20px w-20px m-1"
                  type="radio"
                  name="cancellation_reason"
                  id="cancellation_reason"
                  value="I have technical problems"
                  onChange={handleChange}
                />
                <span className="m-6">I have technical problems</span>
              </div>

              <div className="col-12 mt-8 fs-3">
                <input
                  className="form-check-input h-20px w-20px m-1"
                  type="radio"
                  name="cancellation_reason"
                  id="cancellation_reason"
                  value="I listen to too few audiobooks"
                  onChange={handleChange}
                />
                <span className="m-6">I listen to too few audiobooks</span>
              </div>

              <div className="col-12 mt-8 fs-3">
                <input
                  className="form-check-input h-20px w-20px m-1"
                  type="radio"
                  name="cancellation_reason"
                  id="cancellation_reason"
                  value="I find the subcription too expensive"
                  onChange={handleChange}
                />
                <span className="m-6">
                  I find the subcription too expensive
                </span>
              </div>

              <div className="col-12 mt-8 fs-3">
                <input
                  className="form-check-input h-20px w-20px m-1"
                  type="radio"
                  name="cancellation_reason"
                  id="cancellation_reason"
                  value="I use another service"
                  onChange={handleChange}
                />
                <span className="m-6">I use another service</span>
              </div>

              <div className="col-12 mt-8 fs-3">
                <input
                  className="form-check-input h-20px w-20px m-1"
                  type="radio"
                  name="cancellation_reason"
                  id="cancellation_reason"
                  value="I can't find any audiobooks I like"
                  onChange={handleChange}
                />
                <span className="m-6">I can't find any audiobooks I like</span>
              </div>
              <div className="col-12 mt-8 fs-3">
                <input
                  className="form-check-input h-20px w-20px m-1"
                  type="radio"
                  name="cancellation_reason"
                  id="cancellation_reason"
                  onChange={handleReasonChange}
                  value=""
                />
                <span className="m-6">Another reason:</span>
              </div>
              {isAnother === "enable" ? (
                <div className="col-12 mt-8 fs-3">
                  <textarea
                    className="form-control form-control-lg form-control-solid"
                    type="text"
                    name="cancellation_reason"
                    id="cancellation_reason"
                    placeholder="Thank you for indicating what we could improve"
                    // onChange={handleChange}
                    required
                    rows="4"
                    cols="50"
                    autoComplete="true"
                    // value=""
                    onChange={handleReasonChange}
                  />
                </div>
              ) : (
                ""
              )}

              <div className="row">
                <div className="col-12 text-center mt-4">
                  <button
                    onClick={cancelSubscription}
                    className="btn btn-dark w-200px"
                  >
                    Cancellation
                  </button>
                </div>
              </div>

              {/* <Link to={`/account/cancellation/confirm`}> Cancellation</Link> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CancelReason;
